angular.module('iconoglobe').controller('EditCommentCtrl', ['$scope', '$http', 'content', '$uibModalInstance', 'LOCALES', 'cookieStore', "APP_VERSION", function($scope, $http, content, $uibModalInstance, LOCALES, cookieStore, APP_VERSION) {
    
    $scope.LOCALES = LOCALES;

    var $ctrl = this;
    $ctrl.content = content;
    var  id = $ctrl.content.commentID; 
    $http.get("/establishment/getCommentByID/" + id).then(function (res) {
        $scope.updateComment = res.data[0].comment;
        console.log(res.data);
    }, function(err) {});

    $scope.ok = function () {
        $http.post("/establishment/updateCommentByID/" + id, {
            comment: $scope.updateComment
        }).then(function (res) {
            console.log(res.data);
            $uibModalInstance.dismiss('confirm');
        }, function(err) {});
        
  
      };
  
      $scope.cancel = function() {
          $uibModalInstance.dismiss('cancel');
      };
  
      $scope.cacheBuster = APP_VERSION.version;
  
  }]);